"use client";

import { useTranslations } from "next-intl";
import { SRCImage } from "react-datocms";

import { useCurrencyFormatter } from "~/lib/use-currency";
import { Link } from "~/navigation";

import { CalendarIcon } from "./icons/calendar-icon";
import { ClockIcon } from "./icons/clock-icon";
import { type TripCardTrip } from "./trip-cards-loader";

export function TripCard({ datoTrip, days, total }: TripCardTrip) {
  const t = useTranslations("TourDetails");
  const tCommon = useTranslations("Common");
  const formatCurrency = useCurrencyFormatter();
  return (
    <Link href={`/trips/${datoTrip.slug}/${datoTrip.id}`}>
      <div className="relative mb-3 overflow-hidden rounded-xl">
        <SRCImage priority={true} data={datoTrip.heroImage.responsiveImage} />

        <div className="absolute inset-x-0 bottom-0 bg-neutral-500/10 text-sm text-white backdrop-blur-md">
          <div className="inset-x-0 top-0 h-[0.5px] backdrop-brightness-125" />
          <div className="flex flex-wrap items-baseline justify-center p-3 pt-2.5 text-sm font-light leading-tight">
            <span className="text-base font-medium lowercase">
              {t("fromAmount", { currencyAmount: formatCurrency(total / 2) })}
            </span>
            <span>{t("perPerson")}</span>
          </div>
        </div>
      </div>
      <div className="mb-3 mt-1 font-medium leading-tight">
        {datoTrip.title}
      </div>
      <div className="space-y-1.5 text-xs text-neutral-500">
        <div className="flex items-center gap-1">
          <CalendarIcon className="size-4 shrink-0" />
          <div>
            <span>{tCommon("duration")} </span>
            <span className="text-neutral-900">
              {tCommon("days", { count: days })}
            </span>
          </div>
        </div>
        <div className="flex items-center gap-1">
          <ClockIcon className="size-4 shrink-0" />
          <div>
            <span>{tCommon("startPlace")} </span>
            <span className="text-neutral-900">
              {datoTrip.tripDestinations[0]?.location.name}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}
